export const ADD_TO_CART = 'ADD_TO_CART';
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART';
export const REMOVE_MENU_FROM_CART = 'REMOVE_MENU_FROM_CART';
export const INCREMENT_CART_ITEM_COUNT = 'INCREMENT_CART_ITEM_COUNT';
export const DECREMENT_CART_ITEM_COUNT = 'DECREMENT_CART_ITEM_COUNT';
export const SET_CART = 'SET_CART';
export const SET_ORDER = 'SET_ORDER';
export const INCREMENT_ORDERED_ITEM_COUNT = 'INCREMENT_ORDERED_ITEM_COUNT';
export const DECREMENT_ORDERED_ITEM_COUNT = 'DECREMENT_ORDERED_ITEM_COUNT';
export const REORDER_SAME_ITEMS = 'REORDER_SAME_ITEMS';
export const REMOVE_FROM_ORDERED_ITEM = 'REMOVE_FROM_ORDERED_ITEM';
export const SET_DISPLAY_ORDER = 'SET_DISPLAY_ORDER';
